const icon = require('./icons/no-movement-100.png')

export const NoMovementIcon = () => {
    return <img src={icon} alt="no movement icon" className="w-full h-full"/>
}
